import idopColor from '@/mixins/idopColor'
export default {
  mixins: [idopColor],
  data () {
    return {
      sortSate: false,
      sortSateLoading: false,
    }
  },
  methods: {
    modifyArray (_Array, fun) {
      return _Array
        .filter(it => it.defaultidop != it.idop)
        .map(fun)
    },
    modifyIdop (val) {
      this.items = this.items.map(it => {
        it.idop = val
        return it
      })
    },
    triggerHeaderIdop (h, params) {
      const text = params.column.title.includes('游戏') ? params.column.title : ''
      if (this.sortSate == true) {
        return h('span', [
          h('span', text+'状态'),
          h('Button', {
            class: {
              'mx-1': true,
            },
            props: {
              shape: 'circle',
              type: 'success',
              disabled: this.sortSateLoading
            },
            on: {
              click: () => this.modifyIdop(1)
            }
          }, '开启'),
          h('Button', {
            props: {
              shape: 'circle',
              type: 'error',
              disabled: this.sortSateLoading
            },
            on: {
              click: () => this.modifyIdop(0)
            }
          }, '关闭'),
        ]);
      } else {

        return h('span', text+'开启/关闭');
      }
    },
    triggerIdop (h, params, keyid, name) {
      const keyname = name ? name : 'idop'
      const text = name ? params.row.auditText : params.row.idopText
      if (this.sortSate == true) {
        const index = this.items.map(it => it[keyid]).indexOf(params.row[keyid])
        return h('i-switch', {
          props: {
            disabled: this.sortSateLoading,
            size: 'large',
            type: 'primary',
            trueColor: "#13ce66",
            falseColor: "#ff4949",
            trueValue: 1,
            falseValue: 0,
            value: params.row[keyname]
          },
          on: {
            'on-change': (value) => {
              const idop = this.items[index][keyname] ? 0 : 1
              this.$set(this.items[index], keyname, idop)
            }
          }
        }, [
          h('span', { slot: 'open' }, '开启'),
          h('span', { slot: 'close' }, '关闭')
        ])
      } else {
        return h('span', {
          class: {
            ...this.idopColor(params.row[keyname])
          }
        }, text);
      }
    }
  }
}